var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"map-container fill-height"},[_vm._m(0),(_setup.ready && _setup.mapLayersConfigData)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"container",attrs:{"id":"map"}})
}]

export { render, staticRenderFns }